import { Button, message, Modal } from 'antd';
import { Dispatch, FC, SetStateAction, useEffect } from 'react';
import { useChangeStatusMutation, useDeleteExpenseAreaMutation } from '../../../../api/expenseAreas';
import { ExpenseAreaI } from '../../../../api/types/expenseareas';
import { CustomErrorType } from '../../../../api/types/global';
import { Loader } from '../../../../components/Loader/Loader';

interface PropsI {
    id: number;
    setArea: Dispatch<SetStateAction<{ id: number | null; type: string }>>;
    refetch: any;
    type: string;
    AllEAs: ExpenseAreaI[] | undefined;
}

export const ChangeStatusModal: FC<PropsI> = ({ id, setArea, refetch, type, AllEAs }) => {
    const [changeStatus, { data, isSuccess, isLoading }] = useChangeStatusMutation();
    const [
        deleteEA,
        { data: deletedData, isSuccess: isSuccessDeletedData, isLoading: isLoadingDeletedData, error, isError }
    ] = useDeleteExpenseAreaMutation();
    console.log('AllEAs', AllEAs);
    useEffect(() => {
        if (isSuccess && data) {
            setArea({ id: null, type: '' });
            message.success(data?.message);
            refetch();
        }
    }, [isSuccess]);

    useEffect(() => {
        if (isSuccessDeletedData && deletedData) {
            setArea({ id: null, type: '' });
            message.success(deletedData?.message);
            refetch();
        }
    }, [isSuccessDeletedData]);

    useEffect(() => {
        if (isError && error) {
            message?.error((error as CustomErrorType)?.data?.message);
        }
    }, [isError]);

    return (
        <Modal
            className={''}
            centered
            open={!!id}
            closeIcon={<div style={{ display: 'none', cursor: 'context-menu' }}></div>}
            width={600}
            footer={
                <div style={{ display: 'flex', justifyItems: 'space-between', gap: '16px', width: '100%' }}>
                    <Button
                        key="back"
                        onClick={() => {
                            setArea({ id: null, type: '' });
                        }}
                        block
                        className="cancel"
                    >
                        Cancel
                    </Button>
                    {type === 'deactivate' ? (
                        <button
                            className="quit"
                            onClick={() => {
                                changeStatus(id);
                            }}
                        >
                            {isLoading ? <Loader /> : 'Deactivate'}
                        </button>
                    ) : type === 'activate' ? (
                        <Button
                            key="back"
                            type="primary"
                            onClick={() => {
                                changeStatus(id);
                            }}
                            block
                            className=""
                        >
                            {isLoading ? <Loader /> : 'Activate'}
                        </Button>
                    ) : type === 'delete' ? (
                        <button
                            className="quit"
                            onClick={() => {
                                deleteEA(id);
                            }}
                        >
                            {isLoadingDeletedData ? <Loader /> : 'Delete'}
                        </button>
                    ) : (
                        ''
                    )}
                </div>
            }
        >
            <div className="modal-confirm">
                <div className="modal-confirm__title" style={{ margin: '0 0 10px 0' }}>
                    {type === 'deactivate' && 'Deactivate expanse area?'}
                    {type === 'activate' && 'Activate expanse area?'}
                    {type === 'delete' && 'Delete expanse area?'}
                </div>
                Are you sure you want to {type} the <b>{AllEAs?.find((elem) => elem.id === id)?.name}</b> expense area?
            </div>
        </Modal>
    );
};
